import AAudioPlayerControl from './index.vue';

AAudioPlayerControl.install = app => {
  app.component(AAudioPlayerControl.name, AAudioPlayerControl);
};

export default AAudioPlayerControl;
